/* global angular, Waypoint */

var ngModule = angular.module('trends');

// analytics tracking for modals
ngModule.directive('modalTracker', ['TagManager', '$location',
    function (TagManager, $location) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var path = '/' + attrs.modalTracker;
                if (attrs.modalTrackerIncludeBase !== undefined) {
                    path = $location.path() + path;
                }
                if (attrs.modalTrackerValue) {
                    path = path + '/' + scope.$eval(attrs.modalTrackerValue);
                }

                TagManager.pageView(path, scope.$eval(attrs.modalTrackerTitle));
            }
        };
    }
]);

// analytics scroll-tracking
// based on https://github.com/angulartics/angulartics-scroll/blob/master/lib/angulartics-scroll.js
ngModule.factory('$waypoint',
    function () {
        return Waypoint;
    }
).run(['$waypoint', '$rootScope', '$window',
    function ($waypoint, $rootScope, $window) {
        var timeout;

        var fn = function () {
            $waypoint.refreshAll();
            timeout = null;
        };

        $rootScope.$watch(function () {
            if (!timeout) {
                timeout = $window.setTimeout(fn);
            }

            return true;
        });

        $rootScope.$on('$stateChangeStart', $waypoint.destroyAll);
    }
]).directive('waypoint', ['TagManager', '$timeout', '$state',
    function (TagManager, $timeout, $state) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                // callbacks to remove watches when no longer needed
                var watches = [];

                var label = attrs.waypoint || element[0].id;
                if (!label) { return; }

                var waypoint;
                var handler = function (direction) {
                    if (direction !== 'down') {
                        return;
                    }
                    TagManager.event('waypoint', {
                        category: attrs.waypointCategory || $state.current.name,
                        label: label
                    });

                    // unbind visibility/title watches
                    angular.forEach(watches, function (watch) {
                        watch();
                    });
                    // remove waypoint now that it has fired
                    this.destroy();
                };

                var setWaypoint = function () {
                    // create waypoint
                    waypoint = element.waypoint({
                        handler: handler,
                        continuous: false,
                        triggeronce: false,
                        offset: attrs.waypointOffset || '50%',
                        enabled: false
                    })[0];

                    // watch visibility of element and enable/disable waypoint as appropriate
                    var watch = scope.$watch(function () {
                        return element.is(':visible');
                    }, function (visible) {
                        if (visible) {
                            // Call after digest cycle to make sure element has been redrawn
                            waypoint.context.refresh();
                            waypoint.enable();
                        } else {
                            waypoint.disable();
                        }
                    });
                    watches.push(watch);
                };

                // Set waypoint after 500ms to avoid premature triggering when page is still loading
                $timeout(setWaypoint, 500);
            }
        };
    }
]);
